import React from 'react';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <p className="m-0 text-center">© 2025 copyright all right reserved</p>
        <p className="m-0 text-center">
          Learn more about my work at <a href="https://www.encryptarx.in" target="_blank" rel="noopener noreferrer">ECX Cybersecurity</a>.
        </p>
      </div>
    </footer>
  );
}
